import { render, staticRenderFns } from "./PageReferenceWidget.vue?vue&type=template&id=1c70de8b&scoped=true"
import script from "./PageReferenceWidget.vue?vue&type=script&lang=js"
export * from "./PageReferenceWidget.vue?vue&type=script&lang=js"
import style0 from "./PageReferenceWidget.vue?vue&type=style&index=0&id=1c70de8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70de8b",
  null
  
)

export default component.exports